__turbopack_context__.v({
  "root": "UltrasignalTF-module__4S5PEa__root",
  "typeformContainer": "UltrasignalTF-module__4S5PEa__typeformContainer",
});
